/**
 * 언어 코드 없이 들어온 주소(예: `/seminar/pre`)를 `/{locale}/seminar/pre`로 보낸다.
 *
 * i18n의 브라우저 언어 감지는 `redirectOn: 'root'`라 루트(`/`)에서만 동작하고,
 * 그 외 주소는 언어 쿠키가 있을 때만 리다이렉트된다.
 * 쿠키가 없는 첫 방문(특히 인앱 브라우저처럼 쿠키 저장소가 따로인 모바일 브라우저)에서는 404가 나므로 여기서 보완한다.
 * 페이지 라우트에만 적용되며 `/api`, 정적 파일, 서버 라우트에는 영향이 없다.
 */
export default defineNuxtRouteMiddleware((to) => {
  // 매칭되는 페이지가 있으면(루트 포함) i18n이 처리한다.
  if (to.matched.length > 0) {
    return
  }

  const { locales } = useNuxtApp().$i18n
  const localeCodes: string[] = locales.value.map(item => (typeof item === 'string' ? item : item.code))
  const firstSegment = to.path.split('/')[1] ?? ''
  if (localeCodes.includes(firstSegment)) {
    return
  }

  // 언어 쿠키 → 브라우저 언어 → 기본 언어 순으로 정한다.
  const locale = useCookieLocale().value || useBrowserLocale() || 'ko'
  return navigateTo(`/${locale}${to.fullPath}`, { redirectCode: 302 })
})
